// Async shader compilation may outlive the mesh that requested it. Disposal waits
// for all readers, including overlapping batches, without retaining idle resources.
const readers = new WeakMap();

export function holdResources(resources) {
  const held = [...new Set(resources)].filter(Boolean);
  for (const resource of held) {
    const entry = readers.get(resource) || { count: 0, dispose: false };
    entry.count += 1; readers.set(resource, entry);
  }
  let released = false;
  return () => {
    if (released) return;
    released = true;
    for (const resource of held) {
      const entry = readers.get(resource);
      if (--entry.count > 0) continue;
      readers.delete(resource);
      if (entry.dispose) resource.dispose();
    }
  };
}

export function disposeOwnedResource(resource) {
  if (!resource) return;
  const entry = readers.get(resource);
  if (entry) entry.dispose = true;
  else resource.dispose();
}
